'use client'

import {
    Box,
    Flex,
    Image,
    Stack,
    Heading,
    Text,
    Link,
    useColorModeValue,
} from '@chakra-ui/react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import SignupCard from './signup'
import LoginCard from './login'

export default function AuthBox({ initShowSignup }) {
    const [showSignup, setShowSignup] = useState(initShowSignup ? true : false)
    const [fading, setFading] = useState(false)
    const navigate = useNavigate()

    const handleLogoClick = (e) => {
        e.preventDefault()
        setFading(true)
        setTimeout(() => navigate('/'), 200)
    }

    return (
        <Flex
            minH="100vh"
            align="center"
            justify="center"
            position="relative"
            overflow="hidden"
            opacity={fading ? 0 : 1}
            transition="opacity 0.2s ease"
        >
            <Box
                position="absolute"
                inset={0}
                bgImage="url('/login-form-sm.webp')"
                bgSize="cover"
                bgPosition="center"
                bgRepeat="no-repeat"
                sx={{
                    '@media (min-height: 1000px)': {
                        bgSize: 'auto 100vh',
                    },
                }}
            />
            <Box position="absolute" inset={0} bg="blackAlpha.400" />

            <Stack
                spacing={8}
                mx="auto"
                maxW="lg"
                w="full"
                py={12}
                px={6}
                position="relative"
                zIndex={1}
            >
                <Box
                    rounded="lg"
                    bg={useColorModeValue('white', 'gray.700')}
                    boxShadow="xl"
                    p={8}
                >
                    <Stack spacing={4}>
                        <Stack align="center">
                            <Heading fontSize="4xl" textAlign="center">
                                {showSignup ? <>Sign Up</> : <>Log In</>}
                            </Heading>
                            <Link onClick={handleLogoClick} cursor="pointer">
                                <Image
                                    src="/attributed-to-logo-sm.webp"
                                    alt="attributed.to"
                                    h="100px"
                                />
                            </Link>
                            <Text fontSize="lg" color="gray.600" textAlign="center">
                                Access Provenance Research from the World's Leading Art Historians
                            </Text>
                        </Stack>
                        {!showSignup ? (
                            <>
                                <LoginCard />
                                <Stack pt={6}>
                                    <Text align="center">
                                        Don't have an account?{' '}
                                        <Link onClick={() => setShowSignup(!showSignup)} color="orange.400">
                                            Signup
                                        </Link>
                                    </Text>
                                </Stack>
                            </>
                        ) : (
                            <>
                                <SignupCard />
                                <Stack pt={6}>
                                    <Text align="center">
                                        Already a user?{' '}
                                        <Link onClick={() => setShowSignup(!showSignup)} color="orange.400">
                                            Login
                                        </Link>
                                    </Text>
                                </Stack>
                            </>
                        )}
                    </Stack>
                </Box>
            </Stack>
        </Flex>
    )
}
